import type { Folder, FolderType } from '@newfront-insurance/files-api';
import type { TreeItem, TreeItemIndex } from 'react-complex-tree';

export interface TreeFolderObjectContext extends Folder {
  isLoading?: boolean;
  preventRemove?: boolean;
  label: string;
  id: string;
  type: string;
}
export interface TreeFolderElement {
  label: string;
  parentId?: string;
  parentType?: string;
  isLoading?: boolean;
  id: string;
  type: string;
  associatedYears?: number[];
  parentFolderType?: FolderType;
  displayName?: string;
}

export type FolderItem = TreeFolderElement | TreeFolderObjectContext;
export type FolderTreeItem = TreeItem<FolderItem>;

export type FolderTreeItemRecord = Record<TreeItemIndex, FolderTreeItem>;

export enum FolderTypes {
  FOLDER = 'folder',
  SUBFOLDER = 'subfolder',
}

export interface NewFolderDataForm {
  accountUuid: string;
  displayName: string;
  name: string;
  associatedYears: string[];
  parentFolderType: FolderType;
}
